export const LAZY_COMPONENTS: Record<string, () => Promise<any>> = {
  './components/notifications-management/notifications-management.component': () =>
    import('./components/notifications-management/notifications-management.component').then(
      (m) => m.NotificationsManagementComponent,
    ),
  './components/not-found/not-found.component': () =>
    import('./components/not-found/not-found.component').then((m) => m.NotFoundComponent),
  './components/events-calendar/events-calendar.component': () =>
    import('./components/events-calendar/events-calendar.component').then(
      (m) => m.EventsCalendarComponent,
    ),
  './components/lost-objects/lost-objects.component': () =>
    import('./components/lost-objects/lost-objects.component').then((m) => m.LostObjectsComponent),
  './components/notes/notes.component': () =>
    import('./components/notes/notes.component').then((m) => m.NotesComponent),
  './components/signatory-managment/signatory-managment.component': () =>
    import('./components/signatory-managment/signatory-managment.component').then(
      (m) => m.SignatoryManagmentComponent,
    ),
  './components/alertman-data/alertman-data.component': () =>
    import('./components/alertman-data/alertman-data.component').then(
      (m) => m.AlertmanDataComponent,
    ),
  './components/chat/chat.component': () =>
    import('./components/chat/chat.component').then((m) => m.ChatComponent),
  './components/email-management/email-management.component': () =>
    import('./components/email-management/email-management.component').then(
      (m) => m.EmailManagementComponent,
    ),
  './components/queries-management/queries-management.component': () =>
    import('./components/queries-management/queries-management.component').then(
      (m) => m.QueriesManagementComponent,
    ),
  './components/avl/avl.component': () =>
    import('./components/avl/avl.component').then((m) => m.AvlComponent),
  './components/incident-classification/incident-classification.component': () =>
    import('./components/incident-classification/incident-classification.component').then(
      (m) => m.IncidentClassificationComponent,
    ),
  './components/regulations-management/regulations-management.component': () =>
    import('./components/regulations-management/regulations-management.component').then(
      (m) => m.RegulationsManagementComponent,
    ),
  './components/product-portfolio/product-portfolio.component': () =>
    import('./components/product-portfolio/product-portfolio.component').then(
      (m) => m.ProductPortfolioComponent,
    ),
  './components/incident-resource-management/incident-resource-management.component': () =>
    import('./components/incident-resource-management/incident-resource-management.component').then(
      (m) => m.IncidentResourceManagementComponent,
    ),
  './components/padron-management/padron-management.component': () =>
    import('./components/padron-management/padron-management.component').then(
      (m) => m.PadronManagementComponent,
    ),
  './components/administration/user-administration/user-administration.component': () =>
    import('./components/administration/user-administration/user-administration.component').then(
      (m) => m.UserAdministrationComponent,
    ),
  './components/administration/user-administration/user-list/user-list.component': () =>
    import('./components/administration/user-administration/user-list/user-list.component').then(
      (m) => m.UserListComponent,
    ),
  './components/administration/user-administration/pending-users/pending-users.component': () =>
    import('./components/administration/user-administration/pending-users/pending-users.component').then(
      (m) => m.PendingUsersComponent,
    ),
  './components/administration/user-administration/user-permissions/user-permissions.component':
    () =>
      import('./components/administration/user-administration/user-permissions/user-permissions.component').then(
        (m) => m.UserPermissionsComponent,
      ),
  './components/administration/user-administration/user-roles/user-roles.component': () =>
    import('./components/administration/user-administration/user-roles/user-roles.component').then(
      (m) => m.UserRolesComponent,
    ),
  './components/administration/user-administration/new-user/new-user.component': () =>
    import('./components/administration/user-administration/new-user/new-user.component').then(
      (m) => m.NewUserComponent,
    ),
  './components/administration/audit/audit.component': () =>
    import('./components/administration/audit/audit.component').then((m) => m.AuditComponent),
  './components/administration/change-password/change-password.component': () =>
    import('./components/administration/change-password/change-password.component').then(
      (m) => m.ChangePasswordComponent,
    ),
  './components/administration/password-recovery/password-recovery.component': () =>
    import('./components/administration/password-recovery/password-recovery.component').then(
      (m) => m.PasswordRecoveryComponent,
    ),
  './components/administration/police-user-administration/police-user-administration.component':
    () =>
      import('./components/administration/police-user-administration/police-user-administration.component').then(
        (m) => m.PoliceUserAdministrationComponent,
      ),
  './components/administration/police-user-administration/police-new-employment/police-new-employment.component':
    () =>
      import('./components/administration/police-user-administration/police-new-employment/police-new-employment.component').then(
        (m) => m.PoliceNewEmploymentComponent,
      ),
  './components/administration/police-user-administration/police-material/police-material.component':
    () =>
      import('./components/administration/police-user-administration/police-material/police-material.component').then(
        (m) => m.PoliceMaterialComponent,
      ),
  './components/administration/police-user-administration/police-units/police-units.component':
    () =>
      import('./components/administration/police-user-administration/police-units/police-units.component').then(
        (m) => m.PoliceUnitsComponent,
      ),
  './components/administration/police-user-administration/police-turns/police-turns.component':
    () =>
      import('./components/administration/police-user-administration/police-turns/police-turns.component').then(
        (m) => m.PoliceTurnsComponent,
      ),
  './components/administration/police-user-administration/police-stations-accessories/police-stations-accessories.component':
    () =>
      import('./components/administration/police-user-administration/police-stations-accessories/police-stations-accessories.component').then(
        (m) => m.PoliceStationsAccessoriesComponent,
      ),
  './components/administration/police-user-administration/police-training/police-training.component':
    () =>
      import('./components/administration/police-user-administration/police-training/police-training.component').then(
        (m) => m.PoliceTrainingComponent,
      ),
  './components/administration/police-user-administration/police-pending-procedure/police-pending-procedure.component':
    () =>
      import('./components/administration/police-user-administration/police-pending-procedure/police-pending-procedure.component').then(
        (m) => m.PolicePendingProcedureComponent,
      ),
  './components/administration/police-user-administration/police-congratulations/police-congratulations.component':
    () =>
      import('./components/administration/police-user-administration/police-congratulations/police-congratulations.component').then(
        (m) => m.PoliceCongratulationsComponent,
      ),
  './components/administration/police-user-administration/police-medical-sick-leave/police-medical-sick-leave.component':
    () =>
      import('./components/administration/police-user-administration/police-medical-sick-leave/police-medical-sick-leave.component').then(
        (m) => m.PoliceMedicalSickLeaveComponent,
      ),
  './components/administration/police-user-administration/police-vacations/police-vacations.component':
    () =>
      import('./components/administration/police-user-administration/police-vacations/police-vacations.component').then(
        (m) => m.PoliceVacationsComponent,
      ),
  './components/administration/police-user-administration/police-particular-weapon/police-particular-weapon.component':
    () =>
      import('./components/administration/police-user-administration/police-particular-weapon/police-particular-weapon.component').then(
        (m) => m.PoliceParticularWeaponComponent,
      ),
  './components/administration/police-user-administration/police-own-business/police-own-business.component':
    () =>
      import('./components/administration/police-user-administration/police-own-business/police-own-business.component').then(
        (m) => m.PoliceOwnBusinessComponent,
      ),
  './components/administration/police-user-administration/police-permissions/police-permissions.component':
    () =>
      import('./components/administration/police-user-administration/police-permissions/police-permissions.component').then(
        (m) => m.PolicePermissionsComponent,
      ),
  './components/administration/police-user-administration/police-professional-data/police-professional-data.component':
    () =>
      import('./components/administration/police-user-administration/police-professional-data/police-professional-data.component').then(
        (m) => m.PoliceProfessionalDataComponent,
      ),
  './components/administration/police-user-administration/police-revision-weapon/police-revision-weapon.component':
    () =>
      import('./components/administration/police-user-administration/police-revision-weapon/police-revision-weapon.component').then(
        (m) => m.PoliceRevisionWeaponComponent,
      ),
  './components/administration/police-user-administration/police-driving-permissions/police-driving-permissions.component':
    () =>
      import('./components/administration/police-user-administration/police-driving-permissions/police-driving-permissions.component').then(
        (m) => m.PoliceDrivingPermissionsComponent,
      ),
  './components/administration/police-user-administration/police-observations/police-observations.component':
    () =>
      import('./components/administration/police-user-administration/police-observations/police-observations.component').then(
        (m) => m.PoliceObservationsComponent,
      ),
  './components/administration/police-user-administration/police-uniformity/police-uniformity.component':
    () =>
      import('./components/administration/police-user-administration/police-uniformity/police-uniformity.component').then(
        (m) => m.PoliceUniformityComponent,
      ),
  './components/administration/police-user-administration/police-remuneration/police-remuneration.component':
    () =>
      import('./components/administration/police-user-administration/police-remuneration/police-remuneration.component').then(
        (m) => m.PoliceRemunerationComponent,
      ),
  './components/administration/police-user-administration/police-terms/police-terms.component':
    () =>
      import('./components/administration/police-user-administration/police-terms/police-terms.component').then(
        (m) => m.PoliceTermsComponent,
      ),
  './components/administration/police-user-administration/police-official-weapon/police-official-weapon.component':
    () =>
      import('./components/administration/police-user-administration/police-official-weapon/police-official-weapon.component').then(
        (m) => m.PoliceOfficialWeaponComponent,
      ),
  './components/administration/administration.component': () =>
    import('./components/administration/administration.component').then(
      (m) => m.AdministrationComponent,
    ),
  './components/administration/incident-classification-administration/incident-classification-administration.component':
    () =>
      import('./components/administration/incident-classification-administration/incident-classification-administration.component').then(
        (m) => m.IncidentClassificationAdministrationComponent,
      ),
  './components/administration/daysbySeniority/daysbySeniority.component': () =>
    import('./components/administration/daysbySeniority/daysbySeniority.component').then(
      (m) => m.DaysbySeniorityComponent,
    ),
  './components/administration/ethylometer-drugsanalyzer-administration/ethylometer-drugsanalyzer-administration.component':
    () =>
      import('./components/administration/ethylometer-drugsanalyzer-administration/ethylometer-drugsanalyzer-administration.component').then(
        (m) => m.EthylometerDrugsanalyzerAdministrationComponent,
      ),
  './components/administration/protocols-administration/protocols-administration.component': () =>
    import('./components/administration/protocols-administration/protocols-administration.component').then(
      (m) => m.ProtocolsAdministrationComponent,
    ),
  './components/administration/protocols-administration/responses-administration/responses-administration.component':
    () =>
      import('./components/administration/protocols-administration/responses-administration/responses-administration.component').then(
        (m) => m.ResponsesAdministrationComponent,
      ),
  './components/administration/protocols-administration/related-normative/related-normative.component':
    () =>
      import('./components/administration/protocols-administration/related-normative/related-normative.component').then(
        (m) => m.RelatedNormativeComponent,
      ),
  './components/administration/protocols-administration/actions-administration/actions-administration.component':
    () =>
      import('./components/administration/protocols-administration/actions-administration/actions-administration.component').then(
        (m) => m.ActionsAdministrationComponent,
      ),
  './components/administration/protocols-administration/messages-administration/messages-administration.component':
    () =>
      import('./components/administration/protocols-administration/messages-administration/messages-administration.component').then(
        (m) => m.MessagesAdministrationComponent,
      ),
  './components/administration/alerters-administration/alerters-administration.component': () =>
    import('./components/administration/alerters-administration/alerters-administration.component').then(
      (m) => m.AlertersAdministrationComponent,
    ),
  './components/right-panel/right-panel.component': () =>
    import('./components/right-panel/right-panel.component').then((m) => m.RightPanelComponent),
  './components/under-construction/under-construction.component': () =>
    import('./components/under-construction/under-construction.component').then(
      (m) => m.UnderConstructionComponent,
    ),
  './components/doc-upload-managment/doc-upload-managment.component': () =>
    import('./components/doc-upload-managment/doc-upload-managment.component').then(
      (m) => m.DocUploadManagmentComponent,
    ),
  './components/minors-incident/minors-incident.component': () =>
    import('./components/minors-incident/minors-incident.component').then(
      (m) => m.MinorsIncidentComponent,
    ),
  './components/police-equipment/supplier-searcher/supplier-searcher.component': () =>
    import('./components/police-equipment/supplier-searcher/supplier-searcher.component').then(
      (m) => m.SupplierSearcherComponent,
    ),
  './components/police-equipment/supplier-management/supplier-management.component': () =>
    import('./components/police-equipment/supplier-management/supplier-management.component').then(
      (m) => m.SupplierManagementComponent,
    ),
  './components/police-equipment/police-assignations/police-assignations.component': () =>
    import('./components/police-equipment/police-assignations/police-assignations.component').then(
      (m) => m.PoliceAssignationsComponent,
    ),
  './components/police-equipment/uniformity/uniformity.component': () =>
    import('./components/police-equipment/uniformity/uniformity.component').then(
      (m) => m.UniformityComponent,
    ),
  './components/police-equipment/stock/stock.component': () =>
    import('./components/police-equipment/stock/stock.component').then((m) => m.StockComponent),
  './components/police-equipment/armour-accesories/armour-accesories.component': () =>
    import('./components/police-equipment/armour-accesories/armour-accesories.component').then(
      (m) => m.ArmourAccesoriesComponent,
    ),
  './components/police-equipment/vehicleregistration/vehicleregistration.component': () =>
    import('./components/police-equipment/vehicleregistration/vehicleregistration.component').then(
      (m) => m.VehicleregistrationComponent,
    ),
  './components/police-equipment/walkietalkie-accesories/walkietalkie-accesories.component': () =>
    import('./components/police-equipment/walkietalkie-accesories/walkietalkie-accesories.component').then(
      (m) => m.WalkietalkieAccesoriesComponent,
    ),
  './components/police-equipment/police-equipment.component': () =>
    import('./components/police-equipment/police-equipment.component').then(
      (m) => m.PoliceEquipmentComponent,
    ),
  './components/police-equipment/question-classification/question-classification.component': () =>
    import('./components/police-equipment/question-classification/question-classification.component').then(
      (m) => m.QuestionClassificationComponent,
    ),
  './components/police-equipment/question-modal/question-modal.component': () =>
    import('./components/police-equipment/question-modal/question-modal.component').then(
      (m) => m.QuestionModalComponent,
    ),
  './components/police-equipment/add-suppliers/add-suppliers.component': () =>
    import('./components/police-equipment/add-suppliers/add-suppliers.component').then(
      (m) => m.AddSuppliersComponent,
    ),
  './components/police-equipment/weaponregistration/weaponregistration.component': () =>
    import('./components/police-equipment/weaponregistration/weaponregistration.component').then(
      (m) => m.WeaponregistrationComponent,
    ),
  './components/police-equipment/billing/billing.component': () =>
    import('./components/police-equipment/billing/billing.component').then(
      (m) => m.BillingComponent,
    ),
  './components/police-equipment/walkietalkieregistration/walkietalkieregistration.component': () =>
    import('./components/police-equipment/walkietalkieregistration/walkietalkieregistration.component').then(
      (m) => m.WalkietalkieregistrationComponent,
    ),
  './components/police-equipment/supplier-personnel-seacher/supplier-personnel-seacher.component':
    () =>
      import('./components/police-equipment/supplier-personnel-seacher/supplier-personnel-seacher.component').then(
        (m) => m.SupplierPersonnelSeacherComponent,
      ),
  './components/police-equipment/accessories-assignation/accessories-assignation.component': () =>
    import('./components/police-equipment/accessories-assignation/accessories-assignation.component').then(
      (m) => m.AccessoriesAssignationComponent,
    ),
  './components/police-equipment/stock-return-delivery/stock-return-delivery.component': () =>
    import('./components/police-equipment/stock-return-delivery/stock-return-delivery.component').then(
      (m) => m.StockReturnDeliveryComponent,
    ),
  './components/police-equipment/police-vehicles/police-vehicles.component': () =>
    import('./components/police-equipment/police-vehicles/police-vehicles.component').then(
      (m) => m.PoliceVehiclesComponent,
    ),
  './components/police-equipment/vehicle-assignation/vehicle-assignation.component': () =>
    import('./components/police-equipment/vehicle-assignation/vehicle-assignation.component').then(
      (m) => m.VehicleAssignationComponent,
    ),
  './components/police-equipment/app-notices/app-notices.component': () =>
    import('./components/police-equipment/app-notices/app-notices.component').then(
      (m) => m.AppNoticesComponent,
    ),
  './components/police-equipment/suppliers/suppliers.component': () =>
    import('./components/police-equipment/suppliers/suppliers.component').then(
      (m) => m.SuppliersComponent,
    ),
  './components/police-equipment/canine-effectives/canine-effectives.component': () =>
    import('./components/police-equipment/canine-effectives/canine-effectives.component').then(
      (m) => m.CanineEffectivesComponent,
    ),
  './components/police-equipment/return/return.component': () =>
    import('./components/police-equipment/return/return.component').then((m) => m.ReturnComponent),
  './components/police-equipment/qr/qr.component': () =>
    import('./components/police-equipment/qr/qr.component').then((m) => m.QrComponent),
  './components/police-equipment/delivery/delivery.component': () =>
    import('./components/police-equipment/delivery/delivery.component').then(
      (m) => m.DeliveryComponent,
    ),
  './components/police-equipment/police-searcher/police-searcher.component': () =>
    import('./components/police-equipment/police-searcher/police-searcher.component').then(
      (m) => m.PoliceSearcherComponent,
    ),
  './components/key-control/key-control.component': () =>
    import('./components/key-control/key-control.component').then((m) => m.KeyControlComponent),
  './components/minor-management/minor-management.component': () =>
    import('./components/minor-management/minor-management.component').then(
      (m) => m.MinorManagementComponent,
    ),
  './components/minor-management/minoractions/minoractions.component': () =>
    import('./components/minor-management/minoractions/minoractions.component').then(
      (m) => m.MinoractionsComponent,
    ),
  './components/streetclousure-managment/streetclousure-managment.component': () =>
    import('./components/streetclousure-managment/streetclousure-managment.component').then(
      (m) => m.StreetclousureManagmentComponent,
    ),
  './components/streetclousure-managment/streetclosure-calendar/streetclosure-calendar/streetclosure-calendar.component':
    () =>
      import('./components/streetclousure-managment/streetclosure-calendar/streetclosure-calendar/streetclosure-calendar.component').then(
        (m) => m.StreetclosureCalendarComponent,
      ),
  './components/home/home.component': () =>
    import('./components/home/home.component').then((m) => m.HomeComponent),
  './components/document-management/document-management.component': () =>
    import('./components/document-management/document-management.component').then(
      (m) => m.DocumentManagementComponent,
    ),
  './components/service-management/calendar-admin/calendar-admin.component': () =>
    import('./components/service-management/calendar-admin/calendar-admin.component').then(
      (m) => m.CalendarAdminComponent,
    ),
  './components/service-management/lists/lists.component': () =>
    import('./components/service-management/lists/lists.component').then((m) => m.ListsComponent),
  './components/service-management/overtimes/overtimes.component': () =>
    import('./components/service-management/overtimes/overtimes.component').then(
      (m) => m.OvertimesComponent,
    ),
  './components/service-management/service-sheet-user/service-sheet-user.component': () =>
    import('./components/service-management/service-sheet-user/service-sheet-user.component').then(
      (m) => m.ServiceSheetUserComponent,
    ),
  './components/service-management/calendar/calendar.component': () =>
    import('./components/service-management/calendar/calendar.component').then(
      (m) => m.CalendarComponent,
    ),
  './components/service-management/holidays/holidays.component': () =>
    import('./components/service-management/holidays/holidays.component').then(
      (m) => m.HolidaysComponent,
    ),
  './components/service-management/permissions-request/permissions-request.component': () =>
    import('./components/service-management/permissions-request/permissions-request.component').then(
      (m) => m.PermissionsRequestComponent,
    ),
  './components/service-management/daycounter/daycounter.component': () =>
    import('./components/service-management/daycounter/daycounter.component').then(
      (m) => m.DaycounterComponent,
    ),
  './components/service-management/service-sheet/service-sheet.component': () =>
    import('./components/service-management/service-sheet/service-sheet.component').then(
      (m) => m.ServiceSheetComponent,
    ),
  './components/service-management/hours-adjustment/hours-adjustment.component': () =>
    import('./components/service-management/hours-adjustment/hours-adjustment.component').then(
      (m) => m.HoursAdjustmentComponent,
    ),
  './components/service-management/schedule/schedule.component': () =>
    import('./components/service-management/schedule/schedule.component').then(
      (m) => m.ScheduleComponent,
    ),
  './components/service-management/pending-procedures/pending-procedures.component': () =>
    import('./components/service-management/pending-procedures/pending-procedures.component').then(
      (m) => m.PendingProceduresComponent,
    ),
  './components/service-management/quadrants/updated-quadrant/updated-quadrant.component': () =>
    import('./components/service-management/quadrants/updated-quadrant/updated-quadrant.component').then(
      (m) => m.UpdatedQuadrantComponent,
    ),
  './components/service-management/quadrants/quadrants.component': () =>
    import('./components/service-management/quadrants/quadrants.component').then(
      (m) => m.QuadrantsComponent,
    ),
  './components/service-management/quadrants/annual-quadrant/annual-quadrant.component': () =>
    import('./components/service-management/quadrants/annual-quadrant/annual-quadrant.component').then(
      (m) => m.AnnualQuadrantComponent,
    ),
  './components/service-management/quadrants/quadrant-user/quadrant-user.component': () =>
    import('./components/service-management/quadrants/quadrant-user/quadrant-user.component').then(
      (m) => m.QuadrantUserComponent,
    ),
  './components/service-management/medical-sick-leave/medical-sick-leave.component': () =>
    import('./components/service-management/medical-sick-leave/medical-sick-leave.component').then(
      (m) => m.MedicalSickLeaveComponent,
    ),
  './components/service-management/service-management.component': () =>
    import('./components/service-management/service-management.component').then(
      (m) => m.ServiceManagementComponent,
    ),
  './components/service-management/rules-specials/rules-specials.component': () =>
    import('./components/service-management/rules-specials/rules-specials.component').then(
      (m) => m.RulesSpecialsComponent,
    ),
  './components/hipatia/hipatia.component': () =>
    import('./components/hipatia/hipatia.component').then((m) => m.HipatiaComponent),
  './components/hipatia/hipatia-incident-created/hipatia-incident-created.component': () =>
    import('./components/hipatia/hipatia-incident-created/hipatia-incident-created.component').then(
      (m) => m.HipatiaIncidentCreatedComponent,
    ),
  './components/diligence-management/diligence-search/diligence-search.component': () =>
    import('./components/diligence-management/diligence-search/diligence-search.component').then(
      (m) => m.DiligenceSearchComponent,
    ),
  './components/diligence-management/police-traffic-complaint/police-traffic-complaint.component':
    () =>
      import('./components/diligence-management/police-traffic-complaint/police-traffic-complaint.component').then(
        (m) => m.PoliceTrafficComplaintComponent,
      ),
  './components/diligence-management/diligence-management.component': () =>
    import('./components/diligence-management/diligence-management.component').then(
      (m) => m.DiligenceManagementComponent,
    ),
  './components/diligence-management/police-reports/police-reports.component': () =>
    import('./components/diligence-management/police-reports/police-reports.component').then(
      (m) => m.PoliceReportsComponent,
    ),
  './components/diligence-management/statement-police/statement-police.component': () =>
    import('./components/diligence-management/statement-police/statement-police.component').then(
      (m) => m.StatementPoliceComponent,
    ),
  './components/diligence-management/police-complaint/police-complaint.component': () =>
    import('./components/diligence-management/police-complaint/police-complaint.component').then(
      (m) => m.PoliceComplaintComponent,
    ),
  './components/diligence-management/diligence-history/diligence-history.component': () =>
    import('./components/diligence-management/diligence-history/diligence-history.component').then(
      (m) => m.DiligenceHistoryComponent,
    ),
  './components/apiexternalconnections/dgt/dgt.component': () =>
    import('./components/apiexternalconnections/dgt/dgt.component').then((m) => m.DgtComponent),
  './components/apiexternalconnections/dgt/dgtvehicleivtm/dgtvehicleivtm.component': () =>
    import('./components/apiexternalconnections/dgt/dgtvehicleivtm/dgtvehicleivtm.component').then(
      (m) => m.Dgtvehicleivtm,
    ),
  './components/apiexternalconnections/dgt/driverpenalties/driverpenalties.component': () =>
    import('./components/apiexternalconnections/dgt/driverpenalties/driverpenalties.component').then(
      (m) => m.DriverpenaltiesComponent,
    ),
  './components/apiexternalconnections/dgt/datasender/datasender.component': () =>
    import('./components/apiexternalconnections/dgt/datasender/datasender.component').then(
      (m) => m.DataSenderComponent,
    ),
  './components/apiexternalconnections/dgt/driverhist/driverhist.component': () =>
    import('./components/apiexternalconnections/dgt/driverhist/driverhist.component').then(
      (m) => m.DriverhistComponent,
    ),
  './components/apiexternalconnections/dgt/driverlicenses/driverlicenses.component': () =>
    import('./components/apiexternalconnections/dgt/driverlicenses/driverlicenses.component').then(
      (m) => m.DriverlicensesComponent,
    ),
  './components/apiexternalconnections/dgt/vehiclepenalties/vehiclepenalties.component': () =>
    import('./components/apiexternalconnections/dgt/vehiclepenalties/vehiclepenalties.component').then(
      (m) => m.VehiclepenaltiesComponent,
    ),
  './components/apiexternalconnections/dgt/dgteucaris/dgteucaris.component': () =>
    import('./components/apiexternalconnections/dgt/dgteucaris/dgteucaris.component').then(
      (m) => m.DgteucarisComponent,
    ),
  './components/apiexternalconnections/dgt/dgtviadamages/dgtviadamages.component': () =>
    import('./components/apiexternalconnections/dgt/dgtviadamages/dgtviadamages.component').then(
      (m) => m.Dgtviadamages,
    ),
  './components/apiexternalconnections/dgt/vehicledata/vehicledata.component': () =>
    import('./components/apiexternalconnections/dgt/vehicledata/vehicledata.component').then(
      (m) => m.VehicledataComponent,
    ),
  './components/apiexternalconnections/apiexternalconnections.component': () =>
    import('./components/apiexternalconnections/apiexternalconnections.component').then(
      (m) => m.ApiexternalconnectionsComponent,
    ),
  './components/apiexternalconnections/padron/padron.component': () =>
    import('./components/apiexternalconnections/padron/padron.component').then(
      (m) => m.PadronComponent,
    ),
  './components/apiexternalconnections/vado/vado.component': () =>
    import('./components/apiexternalconnections/vado/vado.component').then((m) => m.VadoComponent),
  './components/establishments/establishments.component': () =>
    import('./components/establishments/establishments.component').then(
      (m) => m.EstablishmentsComponent,
    ),
  './components/police-records/police-records.component': () =>
    import('./components/police-records/police-records.component').then(
      (m) => m.PoliceRecordsComponent,
    ),
  './components/police-records/modal-records/modal-records.component': () =>
    import('./components/police-records/modal-records/modal-records.component').then(
      (m) => m.ModalRecordsComponent,
    ),
  './components/support/control-view-support/control-view-support.component': () =>
    import('./components/support/control-view-support/control-view-support.component').then(
      (m) => m.ControlViewSupportComponent,
    ),
  './components/support/ticket-support/ticket-support.component': () =>
    import('./components/support/ticket-support/ticket-support.component').then(
      (m) => m.TicketSupportComponent,
    ),
  './components/support/support-management/support-management.component': () =>
    import('./components/support/support-management/support-management.component').then(
      (m) => m.SupportManagementComponent,
    ),
  './components/support/messages-chat-support/messages-chat-support.component': () =>
    import('./components/support/messages-chat-support/messages-chat-support.component').then(
      (m) => m.MessagesChatSupportComponent,
    ),
  './components/dossier-management/police-statement-route/police-statements/police-statements.component':
    () =>
      import('./components/dossier-management/police-statement-route/police-statements/police-statements.component').then(
        (m) => m.PoliceStatementsComponent,
      ),
  './components/dossier-management/police-statement-route/police-statement/police-statement.component':
    () =>
      import('./components/dossier-management/police-statement-route/police-statement/police-statement.component').then(
        (m) => m.PoliceStatementComponent,
      ),
  './components/dossier-management/police-statement-route/police-statement/citizen-involved/citizen-involved.component':
    () =>
      import('./components/dossier-management/police-statement-route/police-statement/citizen-involved/citizen-involved.component').then(
        (m) => m.CitizenInvolvedComponent,
      ),
  './components/dossier-management/police-statement-route/police-statement/vehicle-involved/vehicle-involved.component':
    () =>
      import('./components/dossier-management/police-statement-route/police-statement/vehicle-involved/vehicle-involved.component').then(
        (m) => m.VehicleInvolvedComponent,
      ),
  './components/dossier-management/police-statement-route/police-statement/policeman-involved/policeman-involved.component':
    () =>
      import('./components/dossier-management/police-statement-route/police-statement/policeman-involved/policeman-involved.component').then(
        (m) => m.PolicemanInvolvedComponent,
      ),
  './components/dossier-management/police-statement-route/police-statement/procedure-management/procedure-management.component':
    () =>
      import('./components/dossier-management/police-statement-route/police-statement/procedure-management/procedure-management.component').then(
        (m) => m.ProcedureManagementComponent,
      ),
  './components/dossier-management/police-statement-route/police-statement-route.component': () =>
    import('./components/dossier-management/police-statement-route/police-statement-route.component').then(
      (m) => m.PoliceStatementRouteComponent,
    ),
  './components/dossier-management/dossier-management.component': () =>
    import('./components/dossier-management/dossier-management.component').then(
      (m) => m.DossierManagementComponent,
    ),
  './components/notices/notices.component': () =>
    import('./components/notices/notices.component').then((m) => m.NoticesComponent),
  './components/vehicle-in-storage-management/vehicle-in-storage-management.component': () =>
    import('./components/vehicle-in-storage-management/vehicle-in-storage-management.component').then(
      (m) => m.VehicleInStorageManagementComponent,
    ),
  './components/stadistic/stadistic-component/stadistic-component.component': () =>
    import('./components/statistics/statistics.component').then(
      (m) => m.StatisticsComponents,
    ),
  './components/events-news-management/events-news-management.component': () =>
    import('./components/events-news-management/events-news-management.component').then(
      (m) => m.EventsNewsManagementComponent,
    ),
  './components/incident-management/incident-management.component': () =>
    import('./components/incident-management/incident-management-v2.component').then(
      (m) => m.IncidentManagementV2Component,
    ),
  './components/incident-management/incident-hub.component': () =>
    import('./components/incident-management/incident-hub.component').then(
      (m) => m.IncidentHubComponent,
    ),
  './components/socketuserslogged-management/socketuserslogged-management.component': () =>
    import('./components/socketuserslogged-management/socketuserslogged-management.component').then(
      (m) => m.SocketusersloggedManagementComponent,
    ),
  './components/login/reloginscreen.component': () =>
    import('./components/login/reloginscreen.component').then((m) => m.ReloginScreenComponent),
  './components/login/login.base.component': () =>
    import('./components/login/login.base.component').then((m) => m.LoginBaseComponent),
  './components/login/gcoliva/login.gcoliva.component': () =>
    import('./components/login/gcoliva/login.gcoliva.component').then(
      (m) => m.LoginGCOlivaComponent,
    ),
  './components/login/gisecloud/login.gisecloud.component': () =>
    import('./components/login/gisecloud/login.gisecloud.component').then(
      (m) => m.LoginGisecloudComponent,
    ),
  './components/login/stlucia/login.stlucia.component': () =>
    import('./components/login/stlucia/login.stlucia.component').then(
      (m) => m.LoginStluciaComponent,
    ),
  './components/login/login.component': () =>
    import('./components/login/login.component').then((m) => m.LoginComponent),
  './components/login/solpol/login.solpol.component': () =>
    import('./components/login/solpol/login.solpol.component').then((m) => m.LoginSolpolComponent),
  './components/police-actions/police-actions.component': () =>
    import('./components/police-actions/police-actions.component').then(
      (m) => m.PoliceActionsComponent,
    ),
  './components/customerManagement/inactivityUserTime/inactivityUserTime.component': () =>
    import('./components/customerManagement/inactivityUserTime/inactivityUserTime.component').then(
      (m) => m.InactivityUserTimeComponent,
    ),
  './components/customerManagement/work-conditions-table/work-conditions-table.component': () =>
    import('./components/customerManagement/work-conditions-table/work-conditions-table.component').then(
      (m) => m.WorkConditionsTableComponent,
    ),
  './components/customerManagement/customerManagement.component': () =>
    import('./components/customerManagement/customerManagement.component').then(
      (m) => m.CustomerManagementComponent,
    ),
  './components/customerManagement/DoubleFactorVerificationCode/DoubleFactorVerificationCode.component':
    () =>
      import('./components/customerManagement/DoubleFactorVerificationCode/DoubleFactorVerificationCode.component').then(
        (m) => m.DoubleFactorVerificationCodeComponent,
      ),
  './components/customerManagement/user-session-table/user-session-table.component': () =>
    import('./components/customerManagement/user-session-table/user-session-table.component').then(
      (m) => m.UserSessionTableComponent,
    ),
  './components/customerManagement/incident-classification-migration/incident-classification-migration.component':
    () =>
      import('./components/customerManagement/incident-classification-migration/incident-classification-migration.component').then(
        (m) => m.IncidentClassificationMigrationComponent,
      ),
  './components/calypso/calypso.component': () =>
    import('./components/calypso/calypso.component').then((m) => m.CalypsoComponent),
  './components/blog/blog.component': () =>
    import('./components/blog/blog.component').then((m) => m.BlogComponent),
  './components/grafcan/grafcan.component': () =>
    import('./components/nominatim/nominatim.component').then((m) => m.NominatimComponent),
  './components/drop-downs-management/drop-downs-management.component': () =>
    import('./components/drop-downs-management/drop-downs-management.component').then(
      (m) => m.DropDownsManagementComponent,
    ),
  './components/check-in-out-registry/check-in-out-registry.component': () =>
    import('./components/check-in-out-registry/check-in-out-registry.component').then(
      (m) => m.CheckInOutRegistryComponent,
    ),
  './components/abandoned-vehicle-incident/abandoned-vehicle-incident.component': () =>
    import('./components/abandoned-vehicle-incident/abandoned-vehicle-incident.component').then(
      (m) => m.AbandonedVehicleIncidentComponent,
    ),
  './components/refresh-component/refresh-component.component': () =>
    import('./components/refresh-component/refresh-component.component').then(
      (m) => m.RefreshComponentComponent,
    ),
  './components/police-ids-management/police-ids-management.component': () =>
    import('./components/police-ids-management/police-ids-management.component').then(
      (m) => m.PoliceIDsManagementComponent,
    ),
  './components/police-ids-management/people-localizations-ids/people-localizations-ids.component':
    () =>
      import('./components/police-ids-management/people-localizations-ids/people-localizations-ids.component').then(
        (m) => m.PeopleLocalizationsIdsComponent,
      ),
  './components/police-ids-management/people-review/people-review.component': () =>
    import('./components/police-ids-management/people-review/people-review.component').then(
      (m) => m.PeopleReviewComponent,
    ),
  './components/police-ids-management/people-ids/related-people-ids/related-people-ids.component':
    () =>
      import('./components/police-ids-management/people-ids/related-people-ids/related-people-ids.component').then(
        (m) => m.RelatedPeopleIdsComponent,
      ),
  './components/police-ids-management/people-ids/related-animals-ids/related-animals-ids.component':
    () =>
      import('./components/police-ids-management/people-ids/related-animals-ids/related-animals-ids.component').then(
        (m) => m.RelatedAnimalsIdsComponent,
      ),
  './components/police-ids-management/people-ids/related-vehicles-ids/related-vehicles-ids.component':
    () =>
      import('./components/police-ids-management/people-ids/related-vehicles-ids/related-vehicles-ids.component').then(
        (m) => m.RelatedVehiclesIdsComponent,
      ),
  './components/police-ids-management/people-ids/people-ids-annotations/people-ids-annotations.component':
    () =>
      import('./components/police-ids-management/people-ids/people-ids-annotations/people-ids-annotations.component').then(
        (m) => m.PeopleIdsAnnotationsComponent,
      ),
  './components/police-ids-management/people-ids/people-ids.component': () =>
    import('./components/police-ids-management/people-ids/people-ids.component').then(
      (m) => m.PeopleIdsComponent,
    ),
  './components/police-ids-management/people-records/annotations-records/annotations-records.component':
    () =>
      import('./components/police-ids-management/people-records/annotations-records/annotations-records.component').then(
        (m) => m.AnnotationsRecordsComponent,
      ),
  './components/police-ids-management/people-records/people-records.component': () =>
    import('./components/police-ids-management/people-records/people-records.component').then(
      (m) => m.PeopleRecordsComponent,
    ),
  './components/police-ids-management/people-identification/people-identification.component': () =>
    import('./components/police-ids-management/people-identification/people-identification.component').then(
      (m) => m.PeopleIdentificationComponent,
    ),
  './components/avl-sense/avl-sense.component': () =>
    import('./components/avl-sense/avl-sense.component').then((m) => m.AvlSenseComponent),
  './components/loading/loading.component': () =>
    import('./components/loading/loading.component').then((m) => m.LoadingComponent),
  './components/bulletin-board/bulletin-board.component': () =>
    import('./components/bulletin-board/bulletin-board.component').then(
      (m) => m.BulletinBoardComponent,
    ),
  './components/contacts/contacts.component': () =>
    import('./components/contacts/contacts.component').then((m) => m.ContactsComponent),
  './components/resource-management/intervention-management/intervention-management.component':
    () =>
      import('./components/resource-management/intervention-management/intervention-management.component').then(
        (m) => m.InterventionManagementComponent,
      ),
  './components/resource-management/intervention-management/intervention-resource-list/intervention-resource-list.component':
    () =>
      import('./components/resource-management/intervention-management/intervention-resource-list/intervention-resource-list.component').then(
        (m) => m.InterventionResourceListComponent,
      ),
  './components/resource-management/intervention-management/intervention-list/intervention-list.component':
    () =>
      import('./components/resource-management/intervention-management/intervention-list/intervention-list.component').then(
        (m) => m.InterventionListComponent,
      ),
  './components/resource-management/intervention-management/intervention-panel/intervention-panel.component':
    () =>
      import('./components/resource-management/intervention-management/intervention-panel/intervention-panel.component').then(
        (m) => m.InterventionPanelComponent,
      ),
  './components/resource-management/resource-management.component': () =>
    import('./components/resource-management/resource-management.component').then(
      (m) => m.ResourceManagementComponent,
    ),
  './components/alert/alert.component': () =>
    import('./components/alert/alert.component').then((m) => m.AlertComponent),
  './components/emerg-pc-firemen/emerg-pc-firemen.component': () =>
    import('./components/emerg-pc-firemen/emerg-pc-firemen.component').then(
      (m) => m.EmergPcFiremenComponent,
    ),
  './components/books/books.component': () =>
    import('./components/books/books.component').then((m) => m.BooksComponent),
  '.components/administration/change-password': () =>
    import('./components/administration/change-password/change-password.component').then(
      (m) => m.ChangePasswordComponent,
    ),
  './components/coordination/coordination': () =>
    import('./components/coordination/coordination.component').then(
      (m) => m.CoordinationsComponent,
    ),
  '.components/service-management/service-management.component': () =>
    import('./components/service-management/service-management.component').then(
      (m) => m.ServiceManagementComponent,
    ),
  '.components/cecopin-hub': () =>
    import('./components/cecopin-hub/cecopin-hub.component').then((m) => m.CecopinHubComponent),
   //'./components/reports/reports.component': () =>
   // import('./components/stadistic/stadistic-component/stadistic-component.component').then((m) => m.StadisticComponentComponent),
};
